import { render, staticRenderFns } from "./MenuSap.vue?vue&type=template&id=97edad30"
import script from "./MenuSap.vue?vue&type=script&lang=js"
export * from "./MenuSap.vue?vue&type=script&lang=js"
import style0 from "./MenuSap.vue?vue&type=style&index=0&id=97edad30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports